<template>
  <div>
    <app-header :variant="navBarVariant" />
    <slot />
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name      : 'DefaultLayout',
  components: {
    AppHeader,
    AppFooter,
  },
  props: { navBarVariant: { type: String, default: 'light' } },
}
</script>
